/**
 * Fetches JSON from the S3/CDN path first (cache-busted so edits show up immediately);
 * falls back to the bundled local copy if the remote fetch fails or 404s.
 */
export default async function fetchJsonWithFallback(remoteUrl, localFallback) {
  try {
    const response = await fetch(`${remoteUrl}?t=${Date.now()}`);
    if (!response.ok) {
      throw new Error(`Request failed with status ${response.status}`);
    }
    return await response.json();
  } catch (error) {
    return localFallback;
  }
}
